export const tokenToKey = function(token: string | string[]) {
  return Array.isArray(token) ? token.join(',') : token;
};
